<template>
  <FrameMobile>
    <template v-slot:header> </template>

    <template v-slot:content>
      <MgmInviteBlock />
    </template>

    <template v-slot:footer>
      <FooterMobile class="border-top mcf-border-color" />
    </template>
  </FrameMobile>
</template>

<script>
import FrameMobile from '@/components/mcf/FrameMobile.vue';
import FooterMobile from '@/components/FooterMobile.vue';
import MgmInviteBlock from '@/components/mgm/MgmInviteBlock.vue';

export default {
  components: {
    FrameMobile,
    FooterMobile,
    MgmInviteBlock,
  },
};
</script>

<style>
</style>
